import React from "react";
import styles from "./content.module.scss";

const ContentSection = () => {
  return (
    <section className={styles.container}>
      <h1>Request a price promise refund</h1>
      <div>
        <p>
          Have you bought something with us in the last 7 days, and then found a better price at one of the 25 retailers
          we price match with? Complete this form and we’ll check if you’re due a refund for the difference.
        </p>
        <p>
          We’ll get back to you within 48 hours and if you qualify, we’ll send the refund to your original payment
          method.
        </p>
        <p>Make sure you have your order details or shop receipt ready, as you’ll need them to complete this form.</p>
        <p>First, check you qualify for a price promise refund.</p>
      </div>
    </section>
  );
};

export default React.memo(ContentSection);
